import { useContext } from 'react'
import { SessionContext, type SessionValue } from './SessionProvider'

export const useSession = (): SessionValue => {
  const value = useContext(SessionContext)
  if (value === null) throw new Error('useSession 必須在 SessionProvider 內使用')
  return value
}

export const useReadySession = () => {
  const session = useSession()
  if (session.status !== 'ready') throw new Error('這個畫面必須在選好租戶之後才會出現')
  return session
}
